import * as Dialog from "@radix-ui/react-dialog";
import styles from "./language-modal.module.less";
import { TActionObject } from "../../../types/modal-types";
import { useTranslation } from "react-i18next";
import { TLanguage, TLanguageLink } from "../../../types/language-types";
import Flag from "../flag/flag";
import Link from "../link/link";
import { getModalPortal } from "../../../helpers/modal-helper";

type TLanguageModalProps = {
  currentLanguage: TLanguage;
  languages: Array<TLanguageLink>;
  isOpen?: boolean;
  portalContainer?: HTMLElement | null;
  close?: TActionObject;
  contentClassName?: string;
  overlayClassName?: string;
  onEscapeKeyDown?: () => void;
};

export const LanguageModal = ({
  isOpen = false,
  portalContainer,
  close,
  currentLanguage,
  languages,
  contentClassName,
  overlayClassName,
  onEscapeKeyDown,
}: TLanguageModalProps) => {
  const { t } = useTranslation();
  const onClickOverlay = typeof close?.function === "function" ? close.function : undefined;

  return (
    <Dialog.Root open={isOpen}>
      <Dialog.Portal container={portalContainer ? portalContainer : getModalPortal()}>
        <Dialog.Overlay className={[styles.modalOverlay, overlayClassName ? overlayClassName : ""].join(" ")} />
        <Dialog.Content
          hidden={false}
          onEscapeKeyDown={onEscapeKeyDown}
          onPointerDownOutside={onClickOverlay}
          className={[styles.modalContent, contentClassName ? contentClassName : ""].join(" ")}
        >
          <ul className={styles.list}>
            {languages.map((link) => {
              return (
                <li key={link.language} className={styles.item}>
                  {link.language === currentLanguage && (
                    <button className={styles.itemWrapper} onClick={onClickOverlay}>
                      <div className={[styles.name, "body-base"].join(" ")}>
                        {/*
                          //@ts-ignore */}
                        {t("LANGUAGE_" + link.language.toUpperCase())}
                      </div>
                      <Flag country={link.language} />
                    </button>
                  )}
                  {link.language !== currentLanguage && (
                    <Link url={link.url} className={styles.itemWrapper}>
                      <div className={[styles.name, "body-base"].join(" ")}>
                        {/*
                          //@ts-ignore */}
                        {t("LANGUAGE_" + link.language.toUpperCase())}
                      </div>
                      <Flag country={link.language} />
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
          {/* {typeof close?.function === "function" && (
            <UnstyledButton
              className={styles.closeButton}
              iconLeft={close?.icon ?? "ui-icon-close"}
              onClick={close?.function}
            />
          )} */}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default LanguageModal;
